import { render, staticRenderFns } from "./CoIconGapList.vue?vue&type=template&id=ae1f5370&scoped=true&"
import script from "./CoIconGapList.vue?vue&type=script&lang=ts&"
export * from "./CoIconGapList.vue?vue&type=script&lang=ts&"
import style0 from "./CoIconGapList.vue?vue&type=style&index=0&id=ae1f5370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1f5370",
  null
  
)

export default component.exports